/**
 * Google Consent Mode v2 helpers.
 * - Set default state to denied for non-necessary categories.
 * - Update on user action.
 */

export const CONSENT_STORAGE_KEY = "ecuproyecta_consent_v1";

export const DEFAULT_CONSENT = {
  necessary: true,
  analytics: false,
  marketing: false,
  personalization: false,
};

function ensureDataLayer() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

/**
 * Called once as early as possible (index.html handles the default,
 * but we call it again defensively from JS in case the HTML script was blocked).
 */
export function initConsentDefaults() {
  ensureDataLayer();
  window.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    personalization_storage: "denied",
    functionality_storage: "granted",
    security_storage: "granted",
    wait_for_update: 500,
  });
}

export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_CONSENT, ...parsed };
  } catch (_e) {
    return null;
  }
}

export function applyConsent(consent) {
  ensureDataLayer();
  window.gtag("consent", "update", {
    ad_storage: consent.marketing ? "granted" : "denied",
    ad_user_data: consent.marketing ? "granted" : "denied",
    ad_personalization: consent.marketing ? "granted" : "denied",
    analytics_storage: consent.analytics ? "granted" : "denied",
    personalization_storage: consent.personalization ? "granted" : "denied",
    functionality_storage: "granted",
    security_storage: "granted",
  });
  window.dataLayer.push({
    event: "consent_update",
    consent,
  });
}

export function storeConsent(consent) {
  localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent));
}
